import { get } from '../utils/api';
import { useQuery } from 'react-query';

async function getAllCredits() {
  const res = await get('/user/credits');
  return res.data;
}

export function useCreditsQuery({ enabled = true } = {}) {
  const { data } = useQuery('credits', getAllCredits, { enabled });
  return {
    credits: data,
  };
}
